export const CONTENTA_LOGIN_BTN = '@contenta-login-btn';
export const CONTENTA_SELECTED_SCHEDULE = '@contenta-selected-schedule';
export const CONTENTA_REDIRECT = '@contenta-redirect';
export const CONTENTA_USER = '@contenta-user';
export const CONTENTA_TOKEN = '@contenta-token';
export const CONTENTA_AUTH0_ACCESS_TOKEN = '@contenta-auth0-access-token';
export const CONTENTA_TIMER_CHECKOUT = '@contenta-timer-checkout';
export const STATE_SCHEDULE = '@contenta-state-schedule';

export const CONTENTA_GIFT_CARD = '@contenta-gift-card';
export const CONTENTA_REGISTER_USER = '@contenta-register-user';
export const CONTENTA_BOOKING_DRAFT = '@contenta-booking-draft';
export const CONTENTA_B2B_OAUTH_STATE = '@contenta-b2b-oauth-state';
export const CONTENTA_B2B_ORGANIZATION_ID = '@contenta-b2b-organization-id';
export const CONTENTA_POST_LOGOUT = '@contenta-post-logout';
